import styled from 'styled-components';

import { RadioGroup } from '@gympass/yoga';

export const RadioGroupContainer = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
`;
export const RadioGroupOpt = styled(RadioGroup.Radio)`
  display: flex;
  flex-direction: column;
  margin-right: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;
